/// <reference path="../SecurityMatchRuleset/SecurityMatchRulesetGrid.ts" />
namespace Matrix.Data {

    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.filterable()
    @Serenity.Decorators.registerEditor([Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly])
    export class SecurityMatchRulesetRuleEditor extends Common.GridEditorBase<SecurityMatchRulesetRuleRow> implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Data.SecurityMatchRulesetRules'; }
        protected getIdProperty() { return 'RuleCode'; }
        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            this.slickGrid.setSelectionModel(new Slick.RowSelectionModel());
            Serenity.GridUtils.makeOrderable(this.slickGrid, (items: number[], location: number) => {
                if (!items || !items.length)
                    return;
            });
            this.setHeight();
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.enableDisableFields(true);
            this.slickGrid.onSort.subscribe(function (e, args) {
                this.sortGrid((args.grid as Slick.Grid), args.sortCols[0], args.sortCols[0].sortCol.field);
                (args.grid as Slick.Grid).invalidateAllRows();
                (args.grid as Slick.Grid).invalidate();
                (args.grid as Slick.Grid).render();
                (args.grid as Slick.Grid).resizeCanvas();
            }.bind(this));
        }

        protected layout() {
            super.layout();
            var sortCols = this.slickGrid.getSortColumns();
            this.sortGrid(this.slickGrid, sortCols[0], sortCols[0].columnId);
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var value;
            value = text;
            item[field] = value;
            this.view.refresh();
        }

        protected getDefaultSortBy() {
            return ["Priority"];
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions()
            opt.enableAsyncPostRender = true;
            opt.asyncPostRenderDelay = -1;
            opt.enableAsyncPostRenderCleanup = true;
            return opt;
        }

        protected getPersistanceStorage() {
            return null;
        }

        protected getColumns() {
            var columns = super.getColumns();
            var rowSelectColumn = Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection);
            rowSelectColumn.asyncPostRender = (cellNode: any) => {
                if (!this._readOnly) {
                    this.enableDisableFields(false);
                }
            }
            rowSelectColumn.headerFilterType = Serenity.HeaderFilterType.disabled;
            rowSelectColumn.cssClass = "disabled";
            columns.splice(0, 0, rowSelectColumn);
            columns[0].width = 50;
            columns[2].format = ctx => {
                var klass = 'edit numeric';
                var item = ctx.item as SecurityMatchRulesetRuleEditor;
                var column = ctx.column as Slick.Column;
                var value = item[column.field] as number;
                return "<input type='number' class='" + klass +
                    " priority-row' data-field='" + column.field +
                    "' value='" + value +
                    "' max='32765' disabled />";
            };
            columns[2].asyncPostRender = (cellNode: any, row: number, item: SecurityMatchRulesetRuleRow) => {
                if (this._readOnly) {
                }
            };
            columns[4].format = ctx => {
                if (ctx.value == '1')
                    return "<input  type='checkbox' disabled class='autoreview-row'  name='AutoReview' checked>";
                else
                    return "<input type='checkbox' disabled class='autoreview-row' name='AutoReview' >";
            }
            columns[3].format = ctx => {

                if (ctx.value == '1')
                    return "<input  type='checkbox'  disabled class='enabled-row' name='Enabled' checked>";
                else
                    return "<input type='checkbox' disabled class='enabled-row' name='Enabled' >";
            };
            Q.first(columns, x => x.field == 'RuleCode').format = ctx => {
                return "<span>" + ctx.value + '</span>';
            };
            Q.first(columns, x => x.field == 'RuleCodeDescription').format = ctx => {
                return "<span>" + ctx.value + '</span>';
            };
            Q.first(columns, x => x.field == 'RuleCodeCommandText').format = ctx => {
                return "<span>" + ctx.value + '</span>';
            };
            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {
            super.onClick(e, row, cell);
            let item = this.itemAt(row);
            if ($(e.target).hasClass('enabled-row')) {
                item.Enabled = $(e.target).is(":checked");
                this.slickGrid.invalidate();
            }
            if ($(e.target).hasClass('autoreview-row')) {
                item.AutoReview = $(e.target).is(":checked");
                this.slickGrid.invalidate();
            }
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [
                {
                    title: 'Add Rules',
                    cssClass: 'add-rules-button',
                    icon: 'fa-search-plus',
                    onClick: () => {
                        var dlg = new SecurityMatchRulePickerDialog();
                        dlg.onSuccess = (selected) => {
                            for (var x of selected) {
                                if (this.view.getItemById(x) != null)
                                    continue;
                                var items = this.view.getItems();
                                this.view.addItem({
                                    RuleCode: x.RuleCode,
                                    RuleCodeDescription: x.Description,
                                    RuleCodeCommandText: x.CommandText,
                                    Priority: items.length == 0 ? 1 : (items[items.length - 1].Priority < 32766) ? (Math.floor(items[items.length - 1].Priority || 0) + 1) : 1,
                                    Enabled: true,
                                    AutoReview: true
                                });
                            }
                            return true;
                        };
                        dlg.dialogOpen();
                    }
                }, {
                    title: 'Remove Selected',
                    cssClass: 'remove-selected-button',
                    icon: 'fa-times',
                    onClick: () => {
                        for (var x of this.rowSelection.getSelectedKeys())
                            this.view.deleteItem(x);
                        this.rowSelection.setSelectedKeys([]);
                    }
                }]
        }

        protected enableDisableFields(disabled: boolean) {
            $(".enabled-row").attr("disabled", disabled ? "disabled" : null);
            $(".priority-row").attr("disabled", disabled ? "disabled" : null);
            $(".autoreview-row").attr("disabled", disabled ? "disabled" : null);
            $(".select-all-items").prop("disabled", disabled ? "disabled" : null);
            $(".select-all-items").toggleClass('disabled', disabled)
            $(".r0").toggleClass('disabled', disabled)
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this._value && this._value.length > 0;
        }

        public getEditValue(property, target) {
            target[property.name] = this.value;
        }

        public setEditValue(source, property) {
            this.value = source[property.name];
        }

        private _value: SecurityMatchRulesetRow[];

        private _readOnly: boolean;

        public get_readOnly() {
            return this._readOnly;
        }

        protected setHeight() {
            this.slickContainer.addClass('full-height-page');
            this.slickContainer.css('height', '500px');
            this.slickContainer.css('flex', '1 1 auto');
        }

        public set_readOnly(value: boolean) {
            if (!!value !== !!this._readOnly) {
                this._readOnly = !!value;
                this.toolbar.findButton('add-rules-button').toggleClass('disabled', this._readOnly);
                this.toolbar.findButton('remove-selected-button').toggleClass('disabled', this._readOnly);
                this.enableDisableFields(!!this._readOnly)
            }
        }

        protected sortGrid(grid: Slick.Grid, column: any, field: any) {
            grid.getData().sort(function (a, b) {
                var result = a[field] > b[field] ? 1 :
                    a[field] < b[field] ? -1 :0;
                return column.sortAsc ? result : -result;
            });
        }
    }
}